import mitt from 'mitt'

const eventBus = mitt()

export const setupMitt = (app) => {
  app.config.globalProperties.$eventBus = eventBus
  window.$eventBus = eventBus
}
